import { IconButton } from 'component/Button'
import { RoundButton } from 'component/Button/RoundButton'
import { Modal } from 'component/Modal'
import { Gap, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useBodyScrollLock } from 'hook/useBodyScrollLock'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { CombinePane } from 'page/catalog/combo/CombinePane'
import { FilterAccordion } from 'page/catalog/FilterAccordion/FilterAccordion'
import { PriceAccordion } from 'page/catalog/price/PriceAccordion'
import { useDemo } from 'page/catalog/store/CatalogContext'
import css from './FiltersModal.module.scss'

export const FiltersModal = observer(() => {
  const demo = useDemo()
  const { stand, basic, options, form } = demo
  const { combineFilter } = demo.product

  const {
    brands,
    styles,
    categories,
    colors,
    tsum_categories,
    tsum_seasons,
    tsum_sizes,
    price_filter,
  } = options

  useBodyScrollLock(true)

  const onCancel = useLatestCallback(() => {
    demo.drawer = false
    form.reset()
  })

  const onClear = useLatestCallback(() => {
    demo.drawer = false
    form.clear()
  })

  const onApply = useLatestCallback(() => {
    demo.drawer = false
    form.refresh()
  })

  const content = <Vertical tall>
    <Space pad={32} opposite>
      <Typo size={24} first medium>
        {i18n('Filters')}
      </Typo>
      <IconButton link action={onCancel}>
        <Icon size={32} name="close" />
      </IconButton>
    </Space>

    <Vertical pad={[0, 32, 24, 32]} flex="1 1 auto">
      {brands && <FilterAccordion filter={form.brands} options={brands} />}
      {styles && <FilterAccordion filter={form.styles} options={styles} />}
      {categories && <FilterAccordion filter={form.categories} options={categories} />}
      {tsum_categories && <FilterAccordion filter={form.categories} options={tsum_categories} />}
      {colors && <FilterAccordion filter={form.colors} options={colors} />}
      {tsum_seasons && <FilterAccordion filter={form.seasons} options={tsum_seasons} />}
      {tsum_sizes && <FilterAccordion filter={form.sizes} options={tsum_sizes} />}
      {price_filter && !stand && <PriceAccordion />}
      {combineFilter && !basic && <CombinePane />}
    </Vertical>

    <Gap spring />

    <Space className={css.footer} gap={8} pad={32} wrap opposite>
      <RoundButton onClick={onClear}>
        {i18n('ClearAll')}
      </RoundButton>
      <Space gap={8} wrap>
        <RoundButton fill onClick={onCancel}>
          {i18n('Cancel')}
        </RoundButton>
        <RoundButton primary onClick={onApply}>
          {i18n('Apply')}
        </RoundButton>
      </Space>
    </Space>
  </Vertical>

  return <Modal className={css.modal} width={800} white onCancel={onCancel} closeButton={false}>
    {content}
  </Modal>
})
